module.exports = __webpack_public_path__ + "static/media/bg-me.a10e4eea.png";